// extracted by mini-css-extract-plugin
module.exports = {"minWidth":"styles_minWidth__zDQSK"};